import { useEffect, useState } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import PaginationComponent from '../../components/Pagination/Index';
import styleScss from './styles.module.scss';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate, Link } from 'react-router-dom';
import { getVagaEmpresaCurriculoAll, updatePostulationStatus } from '../../modules/apps/user-management/users-list/core/_requests';
import { useAuth } from '../../modules/auth';
import { LinearLoadingSpinner, LoadingBackdrop } from '../../components/LoadingSpinner/LoadingSpinner';
import BackButton from '../../components/BackButton/BackButton';
import { initValue } from '../../util/Index'
import { listPostulacionModel } from '../../models/ListPostulacionModel'
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import VerifiedIcon from '@mui/icons-material/Verified';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { TableContainer, Paper, TableHead, TableRow, TableCell, TableBody, IconButton, TablePagination, FormControl, InputLabel, Select, Snackbar, Alert, AlertTitle, Dialog, DialogTitle, DialogContentText, DialogContent, DialogActions, TextField } from '@mui/material';
import { Table } from 'react-bootstrap';
import React from 'react';

const EmployerRequestedCandidatoVacancyPage = () => {
	const { currentUser, auth, isAdminRole, isCounselorEmployerRole, isEmployerRole } = useAuth();
	const [data, setData]: any[] = useState([]);
	const [userData, setUserData]: any[] = useState([]);
	const navigate = useNavigate();
	const [total, setTotal] = useState<number>(0);
	const [totalPage, setTotalPage] = useState<number>(0);
	const [filter, setFilter] = useState<any>({
		page: 1,
		limit: 10,
		estado: '',
		autoPostulacion: null
	});
	const [loading, setLoading] = useState(false);
	const id_users = currentUser?.user?.id;
	const id_empresa = currentUser?.user?.empresa_id;
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [requestInProgress, setRequestInProgress] = useState(false);
	const [open, setOpen] = useState(false);
	const [alert, setAlert] = useState(true);
	const [alertMsg, setAlertMsg] = useState('');


	const handleChangePage = (newPage: any) => {
		const newPageNumber = parseInt(newPage) + 1;
		const f = { ...filter, page: newPageNumber };
		setPage(newPage);
		setFilter(f);
	};

	const handleChangeRowsPerPage = (event: any) => {
		const f = { ...filter, page: 1, limit: parseInt(event.target.value, 10) };
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
		setFilter(f);
	};
	const handleFirstPageButtonClick = () => {
		handleChangePage(0);
	};

	const handleLastPageButtonClick = () => {
		handleChangePage(Math.ceil(total / rowsPerPage) - 1);
	};
	const handleClose = () => {
		setOpen(false);
	};

	useEffect(() => {
		setUserData({ ...userData, id_users: currentUser?.user?.id });
	}, []);

	useEffect(() => {
		handleSubmit();
	}, [filter]);

	const changePaginate = (pf: any) => {
		const f = { page: pf.page, limit: pf.limit };
		setFilter(f);
	};

	const isAdminCouselorOrEmployer = () => {
		return isAdminRole() || isCounselorEmployerRole() || isEmployerRole();
	}

	const handleSubmit = async () => {
		setLoading(true);
		try {
			const response = await getVagaEmpresaCurriculoAll(
				`page=${filter.page}&limit=${filter.limit}&id_empresa=${id_empresa}&nome=${userData.nombre_candidato?.trim()}&estado=${filter.estado}&autoPostulacion=${filter.autoPostulacion}`
			);
			if (response && response.data) {
				setTotal(response.data.total);
				setTotalPage(response.data.totalPages);
				setData(response.data.data);
			}
		} catch (error: any) {
			if (error.response) {
				console.error(error.response.data.error);
			} else {
				console.error('Ocurrio un error procesando la solicitud.');
			}
		} finally {
			setLoading(false);
		}
	};

	const MenuAction = (props: any) => {
		const { data } = props;
		const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
		const open = Boolean(anchorEl);
		const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
			setAnchorEl(e.currentTarget)
		};
		const handleClose = () => {
			setAnchorEl(null);
		};

		const [openModalGestionPostulacion, setOpenModalGestionPostulacion] = useState(false);
		const [statusGestionPostulacion, setStatusGestionPostulacion] = useState('REMITIDA');

		/**
		 * Llamado servicio API para actualizar la postulación
		 * @param statusApproval 
		 */
		const updatePostulacion = async (statusApproval: any) => {
			try {
				setRequestInProgress(true);
				await updatePostulationStatus({ id: data.id_post, status: statusApproval });
				setOpen(true);
				setAlert(true);
				setFilter({ ...filter });
				setAlertMsg(`Postulación ${listPostulacionModel.find(i => i.code == statusGestionPostulacion)?.value || 'gestionada'} con éxito!`)
			} catch (error: any) {
				if (error.response) {
					console.error(error.response.data.error);
					setOpen(true);
					setAlert(false);
					setAlertMsg(error.response.data.error);
				} else {
					console.error('Ocurrio un error procesando la solicitud.');
				}
			} finally {
				setTimeout(() => {
					setOpen(false);
				}, 10000);
				setRequestInProgress(false);
			}
		}

		/**
		 * Open modal confirmación gestion postulacion
		 * @param statusApproval 
		 */
		const openConfirmModalGestionPostulacion = (statusApproval: any) => {
			setStatusGestionPostulacion(statusApproval)
			setOpenModalGestionPostulacion(true);
		};

		/**
		 * Close modal confirmación gestion postulacion
		 */
		const handleCloseModalGestionPostulacion = () => {
			setStatusGestionPostulacion('REMITIDA')
			setOpenModalGestionPostulacion(false);
		};

		return (
			<>
				<Button aria-controls={open ? 'basic-menu' : undefined}
					aria-haspopup="true"
					aria-expanded={open ? 'true' : undefined}
					onClick={handleClick}>
					<i className='bi bi-three-dots' style={{ fontSize: '20px' }}></i>
				</Button>
				<Menu
					id='card-actions-menu'
					anchorEl={anchorEl}
					keepMounted
					open={open}
					onClose={handleClose}
				>
					<MenuItem onClick={handleClose}>
						<Link to={`/empleador/hoja-vida/${data.id}/${data.id_empresa}/${data.id_vagas}`}>
							<RemoveRedEyeIcon />
							&nbsp; Ver candidato
						</Link>
					</MenuItem>
					{(data.status === 'REMITIDA' && isAdminCouselorOrEmployer()) && (
						<MenuItem onClick={handleClose}>
							<a className='pointer' onClick={() => openConfirmModalGestionPostulacion('CONTRATADA')}>
								<VerifiedIcon />
								&nbsp; Contratar
							</a>
						</MenuItem>
					)}
					{(data.status === 'REMITIDA' && isAdminCouselorOrEmployer()) && (
						<MenuItem onClick={handleClose}>
							<a className='pointer' onClick={() => openConfirmModalGestionPostulacion('DESCARTADA')}>
								<UnpublishedIcon />
								&nbsp; Descartar
							</a>
						</MenuItem>
					)}
					<MenuItem onClick={handleClose}>
						<Link to={`/empleador/gestion-bitacoras/${data.id_post}/`}>
							<MenuBookIcon />
							&nbsp; Ver bitácoras
						</Link>
					</MenuItem>
				</Menu>
				{/* Dialog confirmar gestion postulacion */}
				<Dialog
					open={openModalGestionPostulacion}
					keepMounted
					onClose={handleCloseModalGestionPostulacion}
					aria-describedby='alert-dialog-description'
				>
					<DialogTitle id='alert-dialog-title'>{'Gestiónar la postulación'}</DialogTitle>
					<DialogContent>
						<DialogContentText id='alert-dialog-description'>
							¿Está seguro de que desea gestionar como <b>{listPostulacionModel.find(i => i.code == statusGestionPostulacion)?.value || 'gestionar'}</b> esta postulación?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							variant='contained'
							sx={{ background: '#960a36', width: 90 }}
							onClick={handleCloseModalGestionPostulacion}
							autoFocus
							disabled={!loading ? false : true}
						>
							Cancelar
						</Button>
						<Button
							variant='contained'
							sx={{ background: '#0A4396', width: 90 }}
							onClick={() => updatePostulacion(statusGestionPostulacion)}
							autoFocus
							disabled={!loading ? false : true}
						>
							Aceptar
						</Button>
					</DialogActions>
				</Dialog>
			</>
		);
	};

	const [textoBuscar, setTextoBuscar] = useState('');
	const filtraTextoBuscar = () => {
		setPage(0);
		setFilter({ ...filter, page: 1 });
	}
	const handleChageTextoBuscar = (event: any) => {
		setTextoBuscar(event.target.value);
		setUserData({ ...userData, nombre_candidato: event.target.value });
	}
	const handleKeyDownEnterTextoBuscar = (event: any) => {
		if (event.key === 'Enter') {
			filtraTextoBuscar();
		}
	}

	return (
		<>
			<div className='p-4 shadow-4 rounded-3 mt-15' style={{ backgroundColor: '#FFFF' }}>
				<LoadingBackdrop loading={requestInProgress} />
				<div className='row mb-4'>
					<div className='col-sm-12'>
						<div className='input-group d-flex' style={{ width: '100%' }}>
							<div style={{ padding: '10px 0px 0px 0px' }}>
								<div className='col-xs-2 col-sm-1 col-md-1'
									style={{
										display: 'contents',
										justifyContent: 'center',
										alignItems: 'center'
									}} >
									<BackButton />
								</div>
							</div>
							<div className='col-xs-12 col-sm-6 col-md-3' style={{ padding: '10px 0px 0px 15px' }}>
								<FormControl fullWidth size="small" sx={{ minWidth: 175 }} >
									<InputLabel id='aupostulado'
										style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>¿Autopostulado?</InputLabel>
									<Select
										style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center', paddingTop: '2.48px', paddingBottom: '2.48px' }}
										labelId='aupostulado'
										id='aupostulado'
										label='¿Autopostulado?'
										value={initValue(filter.autoPostulacion)}
										onChange={(e) => {
											setPage(0);
											setFilter({ ...filter, page: 1, autoPostulacion: e.target.value });
										}}
									>
										<MenuItem value=''>Seleccione...</MenuItem>
										<MenuItem value='true'>Sí</MenuItem>
										<MenuItem value='false'>No</MenuItem>
									</Select>
								</FormControl>
							</div>
							<div className='col-xs-12 col-sm-6 col-md-3' style={{ padding: '10px 0px 0px 15px' }}>
								<FormControl fullWidth sx={{ minWidth: 175 }} size="small">
									<InputLabel id='estado'
										style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>Postulación</InputLabel>
									<Select
										labelId='estado'
										id='estado'
										label='Postulación'
										value={initValue(filter.estado)}
										style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center', paddingTop: '2.48px', paddingBottom: '2.48px' }}
										onChange={(e) => {
											setPage(0);
											setFilter({ ...filter, page: 1, estado: e.target.value });
										}}
									>
										<MenuItem value=''>Seleccione...</MenuItem>
										{listPostulacionModel.map((item) => (
											<MenuItem key={item.code} value={item.code}>
												{item.value}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</div>
							<div className='col-xs-12 col-sm-6 col-md-4' style={{ padding: '10px 0px 0px 15px' }}>
							<TextField
								fullWidth
								size="small"
								value={textoBuscar}
								onChange={handleChageTextoBuscar}
								onKeyDown={handleKeyDownEnterTextoBuscar}
								label="Busca por Candidato/Correo"
								variant="outlined"
								InputProps={{
								endAdornment: (
									<IconButton onClick={filtraTextoBuscar}>
									<i className={`bi ${styleScss['bi-search2']} bi-search`} style={{ fontSize: '20px' }}></i>
									</IconButton>
								),
								}}
								sx={{
								fontFamily: 'Poppins',
								'& .MuiOutlinedInput-root': {
									height: '38px',
								},
								'& .MuiInputBase-input': {
									padding: '8.5px 14px',
									fontFamily: 'Poppins',
									fontSize: '14.5px',
								},
								'& .MuiInputLabel-root': {
									whiteSpace: 'normal',
									lineHeight: '1.2',
									fontFamily: 'Poppins',
								},
								}}
							/>
							</div>
						</div>
					</div>
				</div>
				{loading && <LinearLoadingSpinner isLoading={loading} />}
				{data.lenght !== 0 && (
					<TableContainer component={Paper}>
						<Table className={`table table-responsive table-striped`} style={{ textAlign: 'center' }}>

							<TableHead className={`${styleScss['th-custom']}`}>
								<TableRow>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center', paddingLeft: '8px' }}>
										<h4>Candidato</h4>
									</TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
										<h4>Documento</h4>
									</TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
										<h4>Correo electrónico</h4>
									</TableCell>
									{/* <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
										<h4>Teléfono</h4>
									</TableCell> */}
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
										<h4>Código Vacante</h4>
									</TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
										<h4>Nombre Vacante</h4>
									</TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
										<h4>Postulación</h4>
									</TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
										<h4>Autopostulado</h4>
									</TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
										<h4>Acciones</h4>
									</TableCell>
								</TableRow>
							</TableHead>

							<TableBody>
								{!loading && data.map((x: any, i: any) => (
									<TableRow key={i} id={i.toString()}>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', textAlign: 'center' }} className='pt-3 pb-3' scope='row'>
											{x.nombre_completo}
										</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', wordBreak: 'break-all', textAlign: 'center' }} className={`${styleScss['td-break']}`}>{x.numero_doc}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', wordBreak: 'break-all', textAlign: 'center' }} className={`${styleScss['td-break']}`}>{x.email}</TableCell>
										{/* <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', wordBreak: 'break-all', textAlign: 'center' }} className={`${styleScss['td-break']}`}>{x.celular}</TableCell> */}
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', wordBreak: 'break-all', textAlign: 'center' }} className={`${styleScss['td-break']}`}>{x.codigo_vacante}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', wordBreak: 'break-all', textAlign: 'center' }} className={`${styleScss['td-break']}`}>{x.nombre_vacante}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', wordBreak: 'break-all', textAlign: 'center' }} className={`${styleScss['td-break']}`}>{x.status &&
											x.status.charAt(0).toUpperCase() + x.status.slice(1).toLowerCase()
										}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', wordBreak: 'break-all', textAlign: 'center' }}>{x.id_counselor ? 'No' : 'Si'}</TableCell>
										<TableCell>
											<MenuAction
												data={x} />
										</TableCell>
									</TableRow>
								))}
							</TableBody>

							{data.length === 0 && (
								<tfoot>
									<TableRow>
										<TableCell colSpan={6}>
											<p className='text-center' style={{ width: '100%', textAlign: 'center' }}>
												No se encontraron registros
											</p>
										</TableCell>
									</TableRow>
								</tfoot>
							)}
						</Table>
						<div style={{ fontFamily: 'Poppins', fontSize: '14.5px' }}>
							<TablePagination
								rowsPerPageOptions={[10, 20, 50, 100]}
								component="div"
								style={{ overflow: 'visible', fontFamily: 'Poppins', fontSize: '14.5px' }}
								count={total}
								rowsPerPage={rowsPerPage}
								page={page}
								onPageChange={(event, newPage) => handleChangePage(newPage)}
								onRowsPerPageChange={handleChangeRowsPerPage}
								labelRowsPerPage="Filas por página:"
								labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
								ActionsComponent={({ onPageChange, page: number, count, rowsPerPage }) => (
									<div style={{ display: 'flex', alignItems: 'center', fontFamily: 'Poppins', fontSize: '14.5px' }}>
										<IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
											<FirstPageIcon />
										</IconButton>
										<IconButton onClick={(event) => onPageChange(event, page - 1)} disabled={page === 0} aria-label="previous page">
											<ChevronLeftIcon />
										</IconButton>
										<IconButton onClick={(event) => onPageChange(event, page + 1)} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
											<ChevronRightIcon />
										</IconButton>
										<IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
											<LastPageIcon />
										</IconButton>
									</div>
								)}
							/>
						</div>
						<Snackbar
							anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
							open={open}
							onClose={handleClose}
						>
							<Alert
								onClose={handleClose}
								variant={'filled'}
								severity={alert ? 'success' : 'error'}
								sx={{ whiteSpace: 'pre-line' }}
							>
								{alert ? <AlertTitle>Éxito</AlertTitle> : <AlertTitle>Error</AlertTitle>}
								{alertMsg}
							</Alert>
						</Snackbar>
					</TableContainer>
				)}
			</div>
		</>
	);
};

const EmployerRequestedCandidatoVacancyWrapper = () => {
	return (
		<>
			<PageTitle breadcrumbs={[]}>Gestión de candidatos</PageTitle>
			<EmployerRequestedCandidatoVacancyPage />
		</>
	);
};

export { EmployerRequestedCandidatoVacancyWrapper };
